import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table12cData = { [key: string]: ITable12cRow };

export interface ITable12cProps {
  data: Table12cData;
}

interface ITable12cState {
}

interface ITable12cRow {
  driversTotal: number;
  driversFatal: number;
  driversInjuryA: number;
  driversInjuryB: number;
  driversInjuryC: number;
  pedestriansTotal: number;
  pedestriansFatal: number;
  pedestriansInjuryA: number;
  pedestriansInjuryB: number;
  pedestriansInjuryC: number;
}

const sortOrder = [
  "Apparently Normal",
  "Asleep or Fatigued",
  "Emotional (depressed, angry, disturbed, etc.)",
  "Ill (sick, fainted)",
  "Physically Impaired",
  "Under Influence of Alcohol, Drugs or Medication",
  "Not Applicable",
  "Unknown",
  "Not Stated",
];

export default class Table12c extends React.Component<ITable12cProps, ITable12cState> {
  constructor(props: ITable12cProps) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <>
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 600 }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={3} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">12c</span>
                    <span className="header-text">
                      <div>DRIVER AND PEDESTRIAN CONDITION AT TIME OF CRASH</div>
                      <small>Up to 4 actions per non-motorist</small>
                    </span>
                  </div>
                </th>
                <th colSpan={5} className="border-right-bold">DRIVERS IN CRASHES</th>
                <th colSpan={5}>PEDESTRIANS IN CRASHES</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3} className="border-right-bold">INJURY</th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th className="border-right-bold">C*</th>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key, index) => {
                const row = this.props.data[key];
                return (
                  <tr key={key} className={key === "TOTAL" ? "border-bold bold-text" : null}>
                    <td className="border-right-bold">{key}</td>
                    <td className="numberTotals">{row.driversTotal}</td>
                    <td className="numberTotals">{row.driversFatal}</td>
                    <td className="numberTotals">{row.driversInjuryA}</td>
                    <td className="numberTotals">{row.driversInjuryB}</td>
                    <td className="numberTotals border-right-bold">{row.driversInjuryC}</td>
                    <td className="numberTotals">{row.pedestriansTotal}</td>
                    <td className="numberTotals">{row.pedestriansFatal}</td>
                    <td className="numberTotals">{row.pedestriansInjuryA}</td>
                    <td className="numberTotals">{row.pedestriansInjuryB}</td>
                    <td className="numberTotals">{row.pedestriansInjuryC}</td>
                  </tr>)
              }
              )}
            </tbody>
          </table>
        </>
        : <p>Loading...</p>
    );
  }
}
